import { SupportedLanguage, UserSalutation } from '@/types';

export enum Roles {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
}

export enum RelationStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Blocked = 'BLOCKED',
}

export interface UserInfo {
  firstName: string;
  lastName: string;
  email: string;
  telephone?: string;
  language?: SupportedLanguage;
  salutation?: UserSalutation;
}

export type UserRow = UserData & {
  isMenuOpen: boolean;
};

export interface UserData {
  userId: string;
  requiredMFA: boolean;
  exemptFromMFA: boolean;
  enrolledInMFA: boolean;
  userInfo: UserInfo;
  relationStatus: RelationStatus;
  role: Roles;
}

export interface UserFormCustomer {
  customerId: string;
  legalName?: string;
  isChecked?: boolean;
  role: Roles;
}

export type UserForm = UserInfo & {
  customers: UserFormCustomer[];
};
